import { render, staticRenderFns } from "./RecordsRegister.vue?vue&type=template&id=6df59bac"
import script from "./RecordsRegister.vue?vue&type=script&lang=js"
export * from "./RecordsRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports